import { CATALYST_COLORS_WITH_HEXCODES } from "@certa/catalyst/constants/styles";
import type { DataObjectIndicator } from "@certa/queries/types/dataObjectsAPIs.types";
import styles from "./indicators.module.css";

const INDICATOR_BACKGROUND_COLORS = {
  DARK_RED: CATALYST_COLORS_WITH_HEXCODES.RED_200,
  RED: CATALYST_COLORS_WITH_HEXCODES.RED_100,
  ORANGE: CATALYST_COLORS_WITH_HEXCODES.ORANGE_200,
  YELLOW: CATALYST_COLORS_WITH_HEXCODES.ORANGE_100,
  DARK_GREEN: CATALYST_COLORS_WITH_HEXCODES.GREEN_200,
  GREEN: CATALYST_COLORS_WITH_HEXCODES.GREEN_100
} as const;

const INDICATOR_TEXT_COLORS = {
  DARK_RED: CATALYST_COLORS_WITH_HEXCODES.RED_600,
  RED: CATALYST_COLORS_WITH_HEXCODES.RED_600,
  ORANGE: CATALYST_COLORS_WITH_HEXCODES.ORANGE_600,
  YELLOW: CATALYST_COLORS_WITH_HEXCODES.ORANGE_600,
  GREEN: CATALYST_COLORS_WITH_HEXCODES.GREEN_600,
  DARK_GREEN: CATALYST_COLORS_WITH_HEXCODES.GREEN_600
} as const;

const INDICATOR_BORDER_CLASSNAMES = {
  DARK_RED: styles.ragIndicatorBorderRed,
  RED: styles.ragIndicatorBorderRed,
  ORANGE: styles.ragIndicatorBorderYellow,
  YELLOW: styles.ragIndicatorBorderYellow,
  GREEN: styles.ragIndicatorBorderGreen,
  DARK_GREEN: styles.ragIndicatorBorderGreen
} as const;

export const getIndicatorStyling = (indicator: DataObjectIndicator) => {
  const { color } = indicator;

  return {
    backgroundColor: INDICATOR_BACKGROUND_COLORS[color],
    textColor: INDICATOR_TEXT_COLORS[color],
    borderClassName: INDICATOR_BORDER_CLASSNAMES[color]
  };
};
